import { requestForPendingFeedback } from "api/Appointment";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const usePendingFeedback = (onConfirm: () => void) => {
  const queryClient = useQueryClient();
  return useMutation(requestForPendingFeedback, {
    onSuccess: () => {
      queryClient.invalidateQueries("appointments");
      queryClient.invalidateQueries(['widgetData', 'Upcoming Appointments'])
      toast.success("Pending feedback sent successfully");
      onConfirm();
    },
    onError: () => {
      toast.error(`Something went wrong`);
    },
  });
};
